import { Box, CircularProgress, makeStyles, Theme } from "@material-ui/core";
import React, { useEffect } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useLogoutMutation, useSaveTokenMutation, useValidateNfcKeyMutation } from "../../graphql/generated/graphql";

const useStyles = makeStyles((theme: Theme) => ({
  progress: {
    padding: theme.spacing(2),
    marginLeft: "auto",
    marginRight: "auto",
    width: 40 + 2 * theme.spacing(2),
    height: 40 + 2 * theme.spacing(2),
  },
}));

export default function NFC()
{
  const classes = useStyles();
  const match = useRouteMatch<{ key: string }>("/nfc/:key");
  const [validateNFCKey] = useValidateNfcKeyMutation()
  const [saveToken] = useSaveTokenMutation();
  const [logout] = useLogoutMutation();
  const history = useHistory();

  useEffect(() =>
  {
    (async () =>
    {
      if(match?.params.key)
      {
        const result = await validateNFCKey({ variables: { NFCKey: decodeURIComponent(match.params.key) } });
        if(result.data?.ValidateNFCKey.success)
        {
          await saveToken({
            variables: { token: result.data.ValidateNFCKey.token! }
          });
          localStorage.setItem("userDisplayName", result.data.ValidateNFCKey.userDisplayName!);
        }
        else
        {
          await logout();
          localStorage.removeItem("userDisplayName");
        }
        history.replace("/");
      }
    })();
  }, [match, history, logout, saveToken, validateNFCKey]);

  return <Box className={classes.progress}><CircularProgress color="secondary" /></Box>;
}
